export default __webpack_public_path__ + "static/media/extra-comfort-dekwall.a69319c9.svg";